<div class="toolbar" role="banner">
    <img
      width="150"
      alt="CodeRize Technologies"
      src="../assets/WaterMark.png"
    />
    <!-- <span style="color:black;margin-left:530px;font-size: medium;font: bold;">Deploy Projects</span> -->
  </div>
  
  <!-- <div class="content" role="main"> -->
  
    <!-- <div class="card highlight-card card-small">
      <img width="40" alt="CodeRize Technologies" src="../assets/favicon.png"/>
      <span>{{ title }}</span>
    
    </div> -->
    <br>
    <br>
    
    

